<script>
	import { onMount } from 'svelte';
	let { aspectRatio = import.meta.env.VITE_RENDER_WIDTH / import.meta.env.VITE_RENDER_HEIGHT, children } = $props();
	
	const size = 262
	let xAlignment = 'left';
	let element;
	let y = 0;
	let height = $state(size);
	let mouseDown = false;
	let rect;
	let width = size / 2;
	
	const minWidth = width;
	const minHeight = minWidth;
	
	
	$effect(() => {
		if (aspectRatio > 1) {
			if (width != height * aspectRatio) {
				let h = height / aspectRatio;
				width = h * aspectRatio;
				height = h;
			}
		} else {
			if (width != height * aspectRatio) {
				width = height * aspectRatio;
				height = width / aspectRatio;
			}
		}
	});
	const mouseDownHandler = function (e) {
		if (!element) return;
		mouseDown = true;
		y = e.clientY;
		rect = element.getBoundingClientRect();
	};

	const mouseMoveHandler = function (e) {
		if (mouseDown) {
			const dy = e.clientY - y;
			let _h = Math.round(rect.height + dy);
			if (_h < window.innerHeight - rect.y) {
				if(aspectRatio > 1) {
					if(_h < minHeight) {
						_h = minHeight;
					}
				} else {
					if(_h * aspectRatio < minWidth) {
						_h = minWidth / aspectRatio;
					}
				}
				width = _h * aspectRatio;
				height = _h;
			}
		}
	};
	const mouseUpHandler = function () {
		mouseDown = false;
	};
	document.addEventListener('mouseup', mouseUpHandler);
</script>

<svelte:window on:mousemove={mouseMoveHandler} />

<div class="resizable z-50" id="resizeMe" style:aspect-ratio={aspectRatio} bind:this={element} style:height={height + 'px'}>
	{@render children?.()}
	<!-- <div class={`resizer ${xAlignment !== 'none' ? (xAlignment === 'left' ? 'resizer-r' : 'resizer-l') : ''}`} onmouseup={mouseUpHandler} onmousedown={mouseDownHandler} role="none"></div> -->
	<div class="resizer resizer-b" onmouseup={mouseUpHandler} onmousedown={mouseDownHandler} role="none"></div>
</div>

<style lang="postcss">
	.resizable {
		position: relative;
		align-items: center;
		display: flex;
		justify-content: center;
		width: auto;
	}
	.resizer {
		position: absolute;
	}

	/* Placed at the right side */
	/* .resizer-r {
		cursor: col-resize;
		height: 100%;
		right: 0;
		top: 0;
		width: 25px;
	} */

	/* Placed at the right side */
	/* .resizer-l {
		cursor: col-resize;
		height: 100%;
		left: 0;
		width: 25px;
	} */

	/* Placed at the bottom side */
	.resizer-b {
		bottom: 0;
		cursor: row-resize;
		height: 25px;
		left: 0;
		width: 100%;
	}
</style>
